export default {"src":"/_next/static/media/favicon.13b9d738.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};